export default {"src":"/_next/static/media/qualityTweet.2535b57f.svg","height":262,"width":399,"blurWidth":0,"blurHeight":0};